/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DecryptPosStoreInput = {|
  storeId: string
|};
export type DecryptPosStoreMutationVariables = {|
  input: DecryptPosStoreInput
|};
export type DecryptPosStoreMutationResponse = {|
  +decryptPosStore: ?{|
    +storeId: ?string
  |}
|};
export type DecryptPosStoreMutation = {|
  variables: DecryptPosStoreMutationVariables,
  response: DecryptPosStoreMutationResponse,
|};
*/


/*
mutation DecryptPosStoreMutation(
  $input: DecryptPosStoreInput!
) {
  decryptPosStore(input: $input) {
    storeId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DecryptPosStorePayload",
    "kind": "LinkedField",
    "name": "decryptPosStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "storeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DecryptPosStoreMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DecryptPosStoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "24af2b661064ba9fba2b00c30a2cfa91",
    "id": null,
    "metadata": {},
    "name": "DecryptPosStoreMutation",
    "operationKind": "mutation",
    "text": "mutation DecryptPosStoreMutation(\n  $input: DecryptPosStoreInput!\n) {\n  decryptPosStore(input: $input) {\n    storeId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '34627606e5d39942a0ef46196322b0bc';

module.exports = node;
